import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PreparationsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getPreparationsCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/preparation/count', options);
  }

  public getPreparationsList(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/preparation/all', options);
  }

  public getPreparationInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { internalId };
    return this.http.get(this.BASE_URL + 'private/v2.0/preparation', options);
  }

  public addNewPreparation(context, lang, udid, image, active, description, code) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { image, active, description, code };
    return this.http.post(this.BASE_URL + 'private/v2.0/preparation', item, options);
  }

  public updatePreparationStatus(context, lang, udid, internalId, active) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active };
    return this.http.patch(this.BASE_URL + 'private/v2.0/preparation', item, options);
  }

  public updatePreparationInfo(context, lang, udid, internalId, active, description, code) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, description, code };
    return this.http.patch(this.BASE_URL + 'private/v2.0/preparation', item, options);
  }

  public updatePreparationImage(context, lang, udid, internalId, image) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, image };
    return this.http.patch(this.BASE_URL + 'private/v2.0/preparation', item, options);
  }

  public deletePreparation(context, lang, udid, internalIds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['body'] = { internalIds };
    return this.http.request('delete', this.BASE_URL + 'private/v2.0/preparation', options);
  }
}
